<template>
    <list-item-with-title
	      ref="psystemEl"
        :title="$t('requisite.crypto-way-input.title')"
        :media="localRequisite.psystem?.imgPath ?? undefined"
        :text="localRequisite.psystem?.name ?? ''"
        :loading="loading"
        :placeholder="$t('requisite.crypto-way-input.placeholder')"
        :link="true"
        :showChevron="localRequisite.isNew()"
        @on-item-click="handleItemClick"
    />
    <list-input-with-title
        ref="addressEl"
        :disabled="!localRequisite.isNew()"
        :title="$t('requisite.target-types.wallet.address-input.title')"
        :placeholder="$t('requisite.target-types.wallet.address-input.placeholder')"
        v-model:text="localRequisite.address"
        @update:text="(value) => handleUpdateRequisiteProp('address', value)"
        :textarea="true"
        :required="true"
        :hint="hintBySysName"
    />
</template>

<script setup lang="ts">
import ListItemWithTitle from "@components/atomic/list-item/ListItemWithTitle.vue";
import {computed, onMounted, ref} from "vue";
import Requisite from "@models/requisite/Requisite";
import ListInputWithTitle from "@components/atomic/list-item/ListInputWithTitle.vue";
import {useTranslate} from "@tolgee/vue";
import RequisitePageController from "@/views/requisites-group/requisite/RequisitePageController";

interface Props {
	requisite: Requisite | null;
	loading?: boolean;
}

interface Emits {
	(e: 'toSelectPsystem'): void
	(e: "update:requisite", value: Requisite): void,
}

const { t } = useTranslate();

const props = defineProps<Props>();
const addressEl = ref(null);
const psystemEl = ref(null);

const controller = RequisitePageController.of();

const { defaultPSystems } = controller;

const localRequisite = ref<Requisite>(new Requisite());
localRequisite.value.psystem = defaultPSystems.wallet;

const hintBySysName = computed(() => {
		if (localRequisite.value.psystem?.sysName) {
			return t.value(`requisite.target-types.wallet.address-input.hints.${localRequisite.value.psystem.sysName}`);
		}
});

const emits = defineEmits<Emits>();

defineExpose({ addressEl, psystemEl })

function handleItemClick() {
    if (localRequisite.value.isNew()) {
	      emits("toSelectPsystem");
    }
}

const handleUpdateRequisiteProp = (prop: 'address', value: string) => {
	localRequisite.value[prop] = value;
	emits('update:requisite', localRequisite.value)
}

onMounted(() => {
	if (props.requisite) {
		localRequisite.value = props.requisite;
	}
})
</script>
